<template>
  <div id="app">
    <SignInModal v-if="modal === 'signin'" />
    <SignUpModal v-else-if="modal === 'signup'" />
    <ForgotPasswordModal v-else-if="modal === 'forgotpassword'" />
    <Loading v-show="loading" />
    <MiniLoading v-show="miniLoading && !loading" />
    <router-view v-if="!loading" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SignInModal from "@/components/Modals/SignInModal";
import SignUpModal from "@/components/Modals/SignUpModal";
import ForgotPasswordModal from "@/components/Modals/ForgotPasswordModal";
import Loading from "@/components/Organisms/Loading";
import MiniLoading from "@/components/Organisms/MiniLoading";
import Firebase from "./firebase";

export default {
  name: "App",
  components: {
    SignInModal,
    SignUpModal,
    ForgotPasswordModal,
    Loading,
    MiniLoading,
  },
  methods: {
    ...mapMutations([
      "loadingStart",
      "loadingEnd",
      "setRegistrationId",
      "setCurrentLatLng",
      "setIsLoggedInWithFirebaseAuth",
    ]),
  },
  computed: {
    ...mapState([
      "loading",
      "shoModalAll",
      "miniLoading",
      "registrationId",
      "registrationData",
      "currentPageName",
      "modal",
      "isLoggedInWithFirebaseAuth",
    ]),
  },
  async mounted() {
    // document.body.addEventListener(
    //   "touchstart",
    //   function (e) {
    //     if (e.touches && e.touches.length > 1) {
    //       e.preventDefault();
    //     }
    //   },
    //   { passive: false },
    // );
    // document.body.addEventListener(
    //   "touchmove",
    //   function (e) {
    //     if (e.touches && e.touches.length > 1) {
    //       e.preventDefault();
    //     }
    //   },
    //   { passive: false },
    // );
    // // ブラウザバックを無効化
    window.addEventListener("popstate", () => {
      location.reload();
    });

    this.loadingStart();
    // まずはログイン状態を確認
    // ログインしていればregistrationsのデータがセットされる + localStorageにidがセットされる
    await Firebase.getIsLoggednInWithFirebaseAuth();

    // localStorageからidを取得
    // ログインしてない場合もlocalStorageにidがあればこれが利用される
    const id = localStorage.getItem("id");

    // ここまでで、idがセットされなければ初回アクセス判定してチュートリアルへ送って終了
    if (!id) {
      if (location.pathname !== "/tutorial") {
        this.$router.push({ name: "Tutorial" });
      }
      this.loadingEnd();
      return;
    }

    // idに紐づく各データを取得
    this.setRegistrationId(id);
    await Firebase.getRegistraion();

    // ユーザー設定が完了しているかのチェック
    const isUserSettingDone = this.registrationData.userSettingDone;

    if (!isUserSettingDone) {
      // ユーザー設定してない場合はユーザー設定画面へ
      if (location.pathname !== "/setting") {
        this.$router.push({ name: "Settings" });
      }
      this.loadingEnd();
      return;
    }

    const lastReasearchAnswerDate = this.registrationData.lastReasearchAnswer;

    if (!lastReasearchAnswerDate) {
      // ユーザー設定してない場合はユーザー設定画面へ
      if (location.pathname !== "/research") {
        this.$router.push({ name: "Research" });
      }
      this.loadingEnd();
      return;
    }

    // 事前アンケートへの最終回答が1週間以上前か調べる
    if (lastReasearchAnswerDate) {
      const lastAnsDate = new Date(lastReasearchAnswerDate);
      const now = new Date();
      const diff = now.getTime() - lastAnsDate.getTime();
      const diffDay = diff / (1000 * 60 * 60 * 24);
      if (diffDay > 7) {
        // 最後の回答が1週間以上前のため、回答を取得し、アンケートフォームへ遷移
        this.$router.push({ name: "Research" });
        this.loadingEnd();
        return;
      }
    }

    // ここまで到達したら全ての事前状態が完了しているのでメイン画面へ
    if (location.pathname !== "/") {
      this.$router.push({ name: "Main" });

      this.loadingEnd();
      return;
    }

    this.loadingEnd();
  },
};
</script>

<style>
html {
  height: 100%;
}
body {
  margin: 0;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue